import HistoricMailsModalView from "../common/historicMails.html";
import SearchMaterialsModalView from "./searchMaterialsModal.html";
import AddNewMaterialModalView from "./addNewMaterialModal.html";



angular.module("materials")
    .controller("EventsMaterialsListCtrl", ['event','LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', '$http', '$window', 'uiGridConstants', 'eventService', 'logService',
        function (event, LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, $http, $window, uiGridConstants, eventService, logService)
        {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_MATERIALS_WRITE");
            $scope.allowMaterialRead = LoginService.permissionExist("MATERIAL_READ");
            $scope.errorUnits = false;
            $scope.existsQuantity = false;
            $scope.loadWharesouseRows = function () {
                Restangular.all('Warehouses').getList({ entity_type: "materials", entity_id: $stateParams.id }).then(function (warehouses) {
                    $scope.selectWarehouses = warehouses;
                   //  $scope.gridWarehouse.warehouse_id = $scope.selectWarehouses[0].id;
                });
            }

            $scope.loadWharesouseRows();


            if(!Array.isArray($scope.$parent.menusItems)) {
                $state.go("events.edit", { id: $stateParams.id });
            } else {
                let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
                if(results.length > 0) {
                    $scope.allowWrite &&= results[0].editable;
                    $scope.allowMaterialRead &&= results[0].visible;
                } else {
                    $scope.allowWrite = false;
                    $scope.allowMaterialRead = false;
                }
            }

            $rootScope.title = $filter('translate')('events.title') + " - " + $filter('translate')('events.materials.materials');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $filter('translate')('events.materials.materials') }
            ];
            $scope.classSize = "col-lg-12 col-md-12";

            function isDefinedAndNotNull(val) {
                return angular.isDefined(val) && val !== null
            }
            function isDefinedAndNotNullOrEmpty(val) {
                return angular.isDefined(val) && val !== null && val !== ""
            }

            $scope.event = event;
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
                { title: $filter('translate')('events.materials.materials') }
            ];
            $rootScope.title = $scope.event.name + " - " + $filter('translate')('events.materials.materials');

            $scope.ConfirmationStatusOptions = [{ value: 'pending', label: $filter('translate')('events.materials.pending') },
                { value: 'returned', label: $filter('translate')('events.materials.returned') }];

            $scope.is_template = $stateParams.is_template == 'true';

            if (!$scope.is_template) { //No es template
                $scope.gridOptionEventMaterials = {
                    pdfTitle: $filter('translate')('events.materials.pdf_title'),
                    exporterMenuCsv: true,
                    enableGridMenu: true,
                    //gridMenuShowHideColumns: false,
                    enableSorting: true,
                    paginationPageSizes: [20, 50, 100],
                    paginationPageSize: 20,
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                    },
                    columnDefs: [
                      { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                      {
                          name: 'confirmation_status', field: 'confirmation_status', displayName: $filter('translate')('events.materials.confirmation_status'),
                          enableFiltering: true, cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"text-align: center;\">" +
                        "<span ng-if=\"row.entity.confirmation_status == 'pending'\" class=\"label label-warning\" style=\"width:75px;display: inline-block;height:19px;\">" + $filter('translate')('events.materials.pending') + "</span>" +
                        "<span ng-if=\"row.entity.confirmation_status == 'returned'\" class=\"label label-info\" style=\"width:75px;display: inline-block;height:19px;\">" + $filter('translate')('events.materials.returned') + "</span>" +
                        "</div>", width: 90, filter: { selectOptions: $scope.ConfirmationStatusOptions, type: uiGridConstants.filter.SELECT },
                      },
                      { name: 'type', field: 'FK_events_materials_materials.FK_materials_materials_types.name', displayName: $filter('translate')('materials.materials_types'), enableFiltering: true, enableHiding: false },
                        { name: 'name', field: 'FK_events_materials_materials.name', displayName: $filter('translate')('events.materials.name'), enableFiltering: true, enableHiding: false },
                        { name: 'quantity', displayName: $filter('translate')('materials.qty'), enableFiltering: true, enableHiding: false },
                      {
                          name: 'is_external', field: 'FK_events_materials_materials.is_external', displayName: $filter('translate')('events.materials.is_external'),
                          filter: gridService.yesNoFilter('materialsFK_events_materials_materials.is_external'), width: 100, enableFiltering: true,
                          cellTemplate: gridService.yesNoTemplate('FK_events_materials_materials.is_external')
                      },
                      //{ name: 'provider_name', field: 'FK_events_materials_materials.provider_name', displayName: $filter('translate')('events.materials.provider_name'), enableFiltering: true },
                      {
                          name: ' ', width: 50, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false,
                          cellTemplate: "<div class=\"ui-grid-cell-contents pull-right\">" +
                              "<a class=\"aColorYellow\" ng-click=\"grid.appScope.EventMaterialHistoricMail(row.entity.id);\"><i class=\"fa fa-envelope-o\"></i></a>" +
                              "<a class=\"aColorYellow  margin-left-10\" ng-click=\"grid.appScope.editEventMaterial(row.entity.id);\"><i class=\"fa fa-edit\"></i></a>" +
                              "<a class=\"aColorYellow  margin-left-10\" ng-click=\"grid.appScope.deleteDialog(row.entity.id,row.entity.FK_events_materials_materials.name);\"  ng-if=\"grid.appScope.allowWrite\"><i class=\"fa fa-remove\"></i></a>" +
                              "</div>"
                      },
                    ],
                    getData: function (options) {
                        options.event_id = $stateParams.id;
                        return Restangular.all('eventsMaterials').getList(options);
                    }
                };
                } else { //Es template
                $scope.gridOptionEventMaterials = {
                    pdfTitle: $filter('translate')('events.materials.pdf_title'),
                    exporterMenuCsv: true,
                    enableGridMenu: true,
                    //gridMenuShowHideColumns: false,
                    enableSorting: true,
                    paginationPageSizes: [20, 50, 100],
                    paginationPageSize: 20,
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                    },
                    columnDefs: [
                      { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                      { name: 'type', field: 'FK_events_materials_materials.materials_types.name', displayName: $filter('translate')('materials.materials_types'), enableFiltering: true, enableHiding: false },
                      { name: 'name', field: 'FK_events_materials_materials.name', displayName: $filter('translate')('events.materials.name'), enableFiltering: true, enableHiding: false },
                      {
                          name: 'is_external', field: 'FK_events_materials_materials.is_external', displayName: $filter('translate')('events.materials.is_external'),
                          filter: gridService.yesNoFilter('FK_events_materials_materials.is_external'), width: 100, enableFiltering: true,
                          cellTemplate: gridService.yesNoTemplate('FK_events_materials_materials.is_external')
                      },
                      //{ name: 'provider_name', field: 'FK_events_materials_materials.provider_name', displayName: $filter('translate')('events.materials.provider_name'), enableFiltering: true },
                      {
                          name: ' ', width: 50, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false,
                          cellTemplate: "<div class=\"ui-grid-cell-contents pull-right\">" +
                              "<a class=\"aColorYellow  margin-left-10\" ng-click=\"grid.appScope.deleteDialog(row.entity.id,row.entity.FK_events_materials_materials.name);\"  ng-if=\"grid.appScope.allowWrite\"><i class=\"fa fa-remove\"></i></a>" +
                              "</div>"
                      },
                    ],
                    getData: function (options) {
                        options.event_id = $stateParams.id;
                        return Restangular.all('eventsMaterials').getList(options);
                    }
                };
            }

            $scope.editEventMaterial = function (id) {
                Restangular.one('EventsMaterials', id).get().then(function (eventMaterial) {
                    $scope.eventMaterial = eventMaterial;
                    (eventMaterial.quantity > 0) ? $scope.existsQuantity = true : $scope.existsQuantity = false;
                    if ($scope.eventMaterial.date_from != null)
                        $scope.eventMaterial.date_from = new Date($scope.eventMaterial.date_from);
                    if ($scope.eventMaterial.date_to != null)
                        $scope.eventMaterial.date_to = new Date($scope.eventMaterial.date_to);
                    if (eventMaterial.FK_events_materials_materials.qty == null)
                        eventMaterial.FK_events_materials_materials.quantity = 1;

                    Restangular.all('BudgetGroups').getList().then(function (budgetGroups) {
                        $scope.selectBudgetGroups = budgetGroups;
                        var budgetGroupNull = {
                            id: null,
                            name: $filter('translate')('events.materials.no_budget_group')
                        }
                        $scope.selectBudgetGroups.unshift(budgetGroupNull);

                    });
                });

                $scope.classSize = "col-lg-8 col-md-8";
                if ($window.pageYOffset > 200 && $rootScope.sizeLg) {
                    $scope.styleMargin = $window.pageYOffset - 100;
                }
            }

            $scope.EventMaterialHistoricMail = function (id) {
                let options: any = {}
                options.module = "material/notify";
                options.code = id + "";
                options.event_id = event.id;

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: HistoricMailsModalView,
                    size: "lg",
                    controller: "historicMailsModalCtrl",
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        options: function () {
                            return options;
                        },
                    }
                });
                //Response del modal
                $modalInstance.result.then(function (data) {
                }, function () {
                    if (!$scope.$$phase) $scope.$apply();
                });
            }

            /*
             * Si lleva el parámetro abro el elemento
             */
            if (angular.isDefined($stateParams.materialId) && $stateParams.materialId != null && $stateParams.materialId != "")
                $scope.editEventMaterial($stateParams.materialId)

            $scope.closeMaterialInfo = function () {
                $scope.classSize = "col-lg-12 col-md-12";
                $scope.eventMaterial = null;
            }

            $scope.saveMaterialInfo = function () {
                Restangular.all('Warehouses').customGET("GetTotalStockInWarehouse", { warehouse_id: $scope.eventMaterial.warehouse_id, product_id: $scope.eventMaterial.material_id, type: "materials" }).then(function (res) {
                    $scope.totalStock = res;

                    if (parseInt($scope.eventMaterial.quantity) > $scope.totalStock) {
                        $scope.errorUnits = true;
                    }
                    else {
                        $scope.errorUnits = false;
                    }

                    if ($scope.existsQuantity) {
                        modalService.message({
                            title: "Error",
                            message: "No es posible editar, elimine y cree denuevo el material.",
                            onAccept: function () {
                                $scope.errorUnits = false;
                            }
                        });
                    } else {
                        if (!$scope.errorUnits) {
                            $scope.eventMaterial.put().then(function (result) {
                                if (angular.isDefined(result.id)) {
                                    toastr.success($filter('translate')('events.materials.edit_success'));
                                    $scope.classSize = "col-lg-12 col-md-12";
                                    $scope.eventMaterial = null;
                                    if (!$scope.is_template) $scope.$parent.loadInfo($stateParams.id);
                                    $scope.gridOptionEventMaterials.gridApi.core.raise.itemChanged($scope);
                                } else {
                                    $scope.errorMessage = result.message;
                                }
                            });
                        }
                    }
                });
            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                modalService.confirm({
                    title: $filter('translate')('events.materials.button_delete'),
                    message: $filter('translate')('events.materials.delete_message') + " " + name + "?",
                    onAccept: function () {
                        let send_notifications = false;
                        if (angular.isDefined($scope.eventMaterial) && $scope.eventMaterial != null && $scope.eventMaterial.send_notifications != null) {
                            send_notifications = $scope.eventMaterial.send_notifications;
                        }
                        Restangular.one('EventsMaterials', id).remove({ send_notifications: send_notifications }).then(function (response) {
                            $scope.gridOptionEventMaterials.gridApi.core.raise.itemChanged($scope);

                            if (!response.success) {
                                modalService.message({
                                    title: $filter('translate')('events.materials.button_delete'),
                                    message: response.message
                                })
                            }

                            if (!$scope.is_template) $scope.$parent.loadInfo($stateParams.id);
                            $scope.closeMaterialInfo();
                        }, function (response) {
                            logService.error("Error with status code", response.status);
                        });
                    }
                });

            };

            $scope.searchMasiveDialog = function () {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: SearchMaterialsModalView,
                    size: "lg",
                    controller: "SearchMaterialsModalCtrl"
                });
                //Response del modal
                $modalInstance.result.then(function (data) {
                    $scope.gridOptionEventMaterials.gridApi.core.raise.itemChanged($scope);
                    if (!$scope.is_template) $scope.$parent.loadInfo($stateParams.id);
                    if (!$scope.$$phase) $scope.$apply();
                    }, function () {
                        if (!$scope.$$phase) $scope.$apply();
                    });

            }; //addPersonsPositionDialog

        }
    ])
    .controller("SearchMaterialsModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'gridService', '$uibModal', function ($scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, gridService, $uibModal) {

        $scope.showResults = false;
        $scope.search = {};

        //Custom function.  return null values instead of undefined
        function isDefinedAndNotNull(val) {
            return angular.isDefined(val) && val !== null
        }

        Restangular.all('Providers').getList().then(function (providers) {
            $scope.selectProviders = providers;
        });

        Restangular.all('MaterialsTypes').getList().then(function (materials_types) {
            $scope.selectTypes = materials_types;
        });

        $scope.searchMaterialOptions = function () {
            $scope.showResults = true;

            if (angular.isDefined($scope.gridMaterialsOptions)) {
                $scope.gridMaterialsOptions.loadData(false);
            } else {
                $scope.gridMaterialsOptions = {
                    exporterMenuCsv: false,
                    enableGridMenu: true,
                    enableHiding: false,
                    enableSelectionBatchEvent: false,//para obtener los seleccionados
                    //gridMenuShowHideColumns: false,
                    paginationPageSizes: [5, 10, 25],
                    paginationPageSize: 5,
                    onRegisterApi: function (gridApi) {
                        $scope.gridMaterialsOptions.gridApi = gridApi;
                    },
                    columnDefs: [
                      { name: 'id', visible: false, enableFiltering: false, enableHiding: false, exporterSuppressExport: true },
                      { name: 'type', field: 'FK_materials_materials_types.name', displayName: $filter('translate')('materials.materials_types'), enableFiltering: false },
                      { name: 'name', displayName: $filter('translate')('materials.name'), enableFiltering: false, enableHiding: false },
                      { name: 'FK_materials_providers.name', displayName: $filter('translate')('materials.provider_name'), enableFiltering: false },
                      {
                          name: 'is_external', displayName: $filter('translate')('events.materials.is_external'), width: 100,
                          enableFiltering: false, enableHiding: false, cellTemplate: gridService.yesNoTemplate('is_external')
                      }
                    ],
                    getData: function (options) {
                        var deferred = $q.defer();
                        options.event_id = $stateParams.id;
                        options.material_type_id = $scope.search.material_type_id;
                        options.name = $scope.search.name;
                        options.provider_id = $scope.search.provider_id;
                        if (isDefinedAndNotNull($scope.search.is_external) && $scope.search.is_external != "") {
                            options.is_external = $scope.search.is_external == 1 ? true : false;
                            if (!options.is_external) options.provider_id = null;
                        }
                        $http({
                            method: 'get',
                            url: (window as any).CONFIG.api_url + 'EventsMaterials/SearchMaterialsOptions',
                            params: options
                        }).then(function (results, status, headers, config) {
                            var data = results.data.rows;
                            data.totalRows = results.data.totalRows;
                            $scope.totalRows = results.data.totalRows;
                            deferred.resolve(data);
                        });
                        return deferred.promise;
                    }
                }; //End gridoptions
            }
        }


        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.addMaterial = function () {
            //Devolvemos el control al principal
            var rows = $scope.gridMaterialsOptions.gridApi.selection.getSelectedRows();
            var ids = new Array();
            angular.forEach(rows, function (row) {
                ids.push(row.id);
            });
            if (ids.length > 0) {
                var materialOptions = { event_id: $stateParams.id, eventMaterials: ids };
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + 'EventsMaterials/AddMaterialToEvent',
                    params: materialOptions

                }).then(function (results, status, headers, config) {
                    //Devolvemos el control al principal
                    $uibModalInstance.close();
                });
            }

        };

        $scope.addNewMaterial = function (is_external) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: AddNewMaterialModalView,
                size: "lg",
                controller: "AddNewMaterialModalCtrl",
                resolve: {
                    is_external: function () {
                        return is_external;
                    },
                }
            });
        }


    }])

.controller("AddNewMaterialModalCtrl", ['$scope', '$uibModalInstance','is_external', function ($scope, $uibModalInstance, is_external) {

    $scope.is_external = is_external;

    $scope.callbackClose = function (mode) {
        $uibModalInstance.dismiss(mode);
    };

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

}]);
